(function () {
  if (window.jpFooterAccordionRegistered) return;
  window.jpFooterAccordionRegistered = true;

  var timers = new WeakMap();
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setOpen(item, open) {
    var button = item.querySelector('[data-jp-accordion-trigger]');
    var panel = item.querySelector('[data-jp-accordion-panel]');
    if (!button || !panel) return;

    var timer = timers.get(panel);
    if (timer) window.clearTimeout(timer);
    timers.delete(panel);

    var startHeight = panel.getBoundingClientRect().height;
    button.setAttribute('aria-expanded', String(open));

    if (reduceMotion.matches) {
      panel.classList.toggle('is-open', open);
      panel.style.height = open ? 'auto' : '0px';
      return;
    }

    panel.style.height = startHeight + 'px';
    panel.classList.toggle('is-open', open);
    // Force the starting height to apply before changing to the target height.
    panel.offsetHeight;
    panel.style.height = open ? panel.scrollHeight + 'px' : '0px';

    timers.set(panel, window.setTimeout(function () {
      if (open) panel.style.height = 'auto';
      timers.delete(panel);
    }, 350));
  }

  function selectedItem(event) {
    var item = event.target.closest && event.target.closest('[data-jp-accordion-item]');
    if (item) return item;

    var sectionId = event.detail && event.detail.sectionId;
    var blockId = event.detail && event.detail.blockId;
    if (!sectionId || !blockId) return null;

    var sections = document.querySelectorAll('.site-footer[data-section-id]');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].dataset.sectionId !== sectionId) continue;
      var items = sections[i].querySelectorAll('[data-jp-accordion-block]');
      for (var j = 0; j < items.length; j++) {
        if (items[j].dataset.jpAccordionBlock === blockId) return items[j];
      }
    }
    return null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-jp-accordion-trigger]');
    if (!button) return;
    var item = button.closest('[data-jp-accordion-item]');
    if (!item || !item.closest('[data-jp-footer-accordion]')) return;
    setOpen(item, button.getAttribute('aria-expanded') !== 'true');
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = selectedItem(event);
    if (item) setOpen(item, true);
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var item = selectedItem(event);
    if (item && item.dataset.openByDefault !== 'true') setOpen(item, false);
  });
})();
